class WishlistButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    console.log('wishlist-button clicked', this.dataset);
    let event = "remove_from_wishlist"
    const payload = {
        "id": this.dataset.product_id,
        "name": this.dataset.productTitle,
        "brand": "ONLY",
        "category": this.dataset.productCategory,
        "price": this.dataset.productPrice,
        "variant": this.dataset.productVariant
    }

    if(this.dataset.added === "false") {
      event = "add_to_wishlist"
    }

    console.log('event', event);
    console.log('payload', payload);
    Shopify.analytics.publish(event, payload);
  }
}

customElements.define('wishlist-button', WishlistButton);

// -----------------------------------------------------------------------------
// CUSTOMER INVOICE LIST (ONLINE / OFFLINE)
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var invoiceSection = document.querySelector('.invoice-section[data-invoice-endpoint]');
  if (!invoiceSection) return;

  var phone = invoiceSection.getAttribute('data-invoice-phone') || '';
  var store = invoiceSection.getAttribute('data-invoice-store') || '';
  var endpoint = invoiceSection.getAttribute('data-invoice-endpoint') || '';

  // If phone is missing, Liquid has already rendered a helpful message.
  if (!phone || !endpoint || !store) return;

  var cache = {
    online: null,
    offline: null
  };
  var currentType = 'online';

  var tabs = invoiceSection.querySelectorAll('.invoice-tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var type = tab.getAttribute('data-invoice-type');
      if (!type || type === currentType) return;

      currentType = type;
      tabs.forEach(function (innerTab) {
        innerTab.classList.toggle('is-active', innerTab === tab);
      });

      loadInvoices(type);
    });
  });

  // Load Website (online) by default
  loadInvoices('online');

  function loadInvoices(type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var errorEl = invoiceSection.querySelector('.invoice-error');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    var table = invoiceSection.querySelector('.invoice-table');
    if (!tbody || !errorEl) return;

    if (table) {
      table.classList.toggle('invoice-table--offline', type === 'offline');
    }

    errorEl.style.display = 'none';
    errorEl.textContent = '';
    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }
    tbody.innerHTML =
      '<tr><td colspan="6">Loading ' + (type === 'online' ? 'website' : 'offline') + ' invoices&hellip;</td></tr>';

    if (cache[type]) {
      renderInvoices(cache[type], type);
      return;
    }

    try {
      var url = new URL(endpoint);
      url.searchParams.set('phone', phone);
      url.searchParams.set('store', store);
      url.searchParams.set('type', type);

      // Do not send credentials so the API can use a simple wildcard CORS policy.
      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function (data) {
          if (!data || data.success !== true || !Array.isArray(data.data)) {
            throw new Error('Unexpected API response');
          }

          cache[type] = data.data;
          renderInvoices(cache[type], type);
        })
        .catch(function (error) {
          console.error('Error fetching invoices', error);
          tbody.innerHTML = '';
          errorEl.textContent = 'Unable to load invoices at the moment. Please try again later.';
          errorEl.style.display = 'block';
          if (emptyMessageEl) {
            emptyMessageEl.style.display = 'none';
            emptyMessageEl.textContent = '';
          }
        });
    } catch (e) {
      console.error('Error building invoice URL', e);
    }
  }

  function renderInvoices(list, type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    if (!tbody) return;

    if (!list || list.length === 0) {
      var message =
        type === 'offline'
          ? 'You do not have any in-store purchases yet.'
          : 'You do not have any online orders yet.';

      // Do not render an empty table row; just show the helper text below.
      tbody.innerHTML = '';

      if (emptyMessageEl) {
        emptyMessageEl.textContent = message;
        emptyMessageEl.style.display = 'block';
      }

      return;
    }

    tbody.innerHTML = '';

    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }

    list.forEach(function (item) {
      var tr = document.createElement('tr');
      var orderNumber = item.salesOrderNumber || '';
      var invoiceNumber = item.invoiceNumber || '';
      var purchaseDate = formatInvoiceDate(item.purchaseDate);
      var amount = item.paidAmount || '';
      var invoiceDate = formatInvoiceDate(item.invoiceDate);
      var url = item.invoiceUrl || '';

      tr.innerHTML =
        '<td>' + escapeHtml(orderNumber) + '</td>' +
        '<td>' + escapeHtml(invoiceNumber) + '</td>' +
        '<td>' + escapeHtml(purchaseDate) + '</td>' +
        '<td>' + escapeHtml(amount) + '</td>' +
        '<td>' + escapeHtml(invoiceDate) + '</td>' +
        '<td class="text-end">' +
        (url
          ? '<a href="' + encodeURI(url) + '" target="_blank" rel="noopener" class="link-faded">View invoice</a>'
          : '') +
        '</td>';

      tbody.appendChild(tr);
    });
  }

  function formatInvoiceDate(raw) {
    if (!raw) return '';

    var value = String(raw).trim();

    // Handle explicit string patterns first so we don't let `new Date`
    // guess and potentially swap day & month for values like 11.03.2023.

    // Pattern like "27.12.2025" or "27.12.2025 20:24:02" (dd.MM.yyyy)
    var dotMatch = value.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
    if (dotMatch) {
      return dotMatch[1] + '/' + dotMatch[2] + '/' + dotMatch[3];
    }

    // Pattern like "2025-12-27" or "2025-12-27T15:00:25.995" (yyyy-MM-dd)
    var dashMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dashMatch) {
      return dashMatch[3] + '/' + dashMatch[2] + '/' + dashMatch[1];
    }

    // As a fallback, let the browser parse the date string if it can.
    var d = new Date(value);
    if (!isNaN(d.getTime())) {
      var dd = String(d.getDate()).padStart(2, '0');
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var yyyy = d.getFullYear();
      return dd + '/' + mm + '/' + yyyy;
    }

    // Last resort: return the original raw value
    return value;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      switch (char) {
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        case '"':
          return '&quot;';
        default:
          return '&#39;';
      }
    });
  }
});